// @flow
import createReducer from '../utils/createReducer';
import { API_CALL_SUCCESS, API_CALL_FAILURE, API_CALL_REQUEST } from '../constants/actionTypes';
import { HALL_OF_FAME } from '../constants/apiTypes';
import decodeHallOfFame from '../normalizers/decodeHallOfFame';

const initialState = {
  currentUserEntry: null,
  entered: false,
  errors: null,
  isLoading: false,
  competitions: []
};

const hallOfFameReducer = createReducer(initialState, {
  [API_CALL_REQUEST]: (state, { api }) => {
    if (api === HALL_OF_FAME) {
      return {
        isLoading: true,
        errors: null
      };
    }
    return {};
  },
  [API_CALL_SUCCESS]: (state, { data, api }) => {
    if (api === HALL_OF_FAME) {
      return {
        ...decodeHallOfFame(data),
        isLoading: false
      };
    }
    return {};
  },
  [API_CALL_FAILURE]: (state, { errors, api }) => {
    if (api === HALL_OF_FAME) {
      return {
        isLoading: false,
        errors
      };
    }
    return {};
  }
});

export default hallOfFameReducer;
